// inspired by https://medium.com/@constgenius/switch-component-with-react-and-tailwind-css-custom-switch-component-in-reactjs-23cf0027c4f0

import {forwardRef, memo, InputHTMLAttributes} from "react";
import Close from "@/icons/close.svg?react";
import Check from "@/icons/check.svg?react";

type TInput = InputHTMLAttributes<HTMLInputElement> & {
  checked: boolean;
};

const Switch = forwardRef<HTMLInputElement, TInput>((props, forwardRef) => (
  <label className="cursor-pointer">
    <input
      type="checkbox"
      className="peer hidden"
      ref={forwardRef}
      {...props}
    />
    <div
      className={`w-14 rounded-full p-1 ${props.checked ? "bg-primary-container/40" : "bg-outline-variant peer-disabled:bg-outline"}`}
    >
      <div
        className={`fill-on-primary-container w-fit rounded-full p-0.5 shadow-sm transition-all duration-300 ${props.checked ? "bg-primary-container translate-x-6" : "bg-outline -rotate-180"}`}
      >
        {props.checked ? (
          <Check className="size-i-1" />
        ) : (
          <Close className="size-i-1" />
        )}
      </div>
    </div>
  </label>
));

export default memo(Switch);
